import { render } from "./adminuser.vue?vue&type=template&id=f75a8b38"
import script from "./adminuser.vue?vue&type=script&lang=ts"
export * from "./adminuser.vue?vue&type=script&lang=ts"
script.render = render

export default script